import { ReactNode, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

interface CollapsibleSectionProps {
	title: string;
	children: ReactNode;
	defaultOpen?: boolean;
	badge?: string;
}

export default function CollapsibleSection({
	title,
	children,
	defaultOpen = false,
	badge,
}: CollapsibleSectionProps) {
	const [isOpen, setIsOpen] = useState(defaultOpen);

	return (
		<div className="border !border-border mt-3 rounded-lg mb-3">
			<button
				className="flex items-center justify-between w-full px-3 py-2 text-left text-sm font-semibold text-text-meta hover:bg-slate-50 transition-colors rounded-lg"
				type="button"
				onClick={() => setIsOpen((prev) => !prev)}
			>
				<div className="flex items-center gap-2">
					{isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
					<span>{title}</span>
				</div>
				{badge && !isOpen && (
					<span className="text-[11px] font-normal text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full">
						{badge}
					</span>
				)}
			</button>
			{isOpen && <div className="px-3 pb-3">{children}</div>}
		</div>
	);
}
